import { NameOnlySchema } from "./NameOnly";
import { z } from "zod";

export type QcBizGuestForConvInfo = z.infer<typeof QcBizGuestForConvInfoSchema>;
export const QcBizGuestForConvInfoSchema = z.object({
  available_from: z.string(),
  available_to: z.string().nullable(),
  code: z.string(),
  conversation_id: z.string(),
  country_code: z.string().nullable(),
  id: z.number(),
  lang_cd: z.string(),
  location_id: z.number(),
  name: z.string(),
  phone_number: z.string().nullable(),
  qr: z.string().nullable(),
  qr_with_lang: z.string().nullable(),
  receive_notice: z.boolean(),
  room_name: NameOnlySchema,
  state: z.string(),
});
